var map = {
	"./5v5ideLogoBlack.png": 28,
	"./5v5ideLogoWhite.png": 81,
	"./draw.png": 46,
	"./empty.png": 267,
	"./equal.png": 268,
	"./flags32.png": 269,
	"./lose.png": 45,
	"./matches-icon.png": 82,
	"./negative.png": 270,
	"./players-icon.png": 33,
	"./positive.png": 271,
	"./question.png": 84,
	"./shoot-logo.png": 83,
	"./taptheball.png": 272,
	"./taptheballpitch.png": 273,
	"./userIcon.png": 42,
	"./win.png": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;